module.exports = __webpack_public_path__ + "img/Nilsen_En_ekte_oestlandsdikter.b8955dd3.jpg";